var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.developer)?_c('netvs-icon',{attrs:{"size":_vm.size,"icon":"development_feature"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }